import { isString } from '../types/predicate'

/**
 * Capitalize only the first letter of the input string
 * @param {string} value input string
 * @return {string} the first letter capitalized string
 */
export const capitalizeFirstLetter = (value: string) => {
  if (!value || !isString(value)) {
    return ''
  }

  return value
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
